<template>
    <div class="notFound">
        <v-container>
            <v-row>
                <v-col class="text-center">
                    <span style="font-family: 'FuturaBlack BT Regular'; font-size: 120px;">404</span>
                    <span class="GTAmerica d-block bold">Page not found</span>

                    <router-link class="GTAmerica black--text not-text-decoration mt-6 d-block" to="/">Back to home</router-link>
                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
export default {
    
}
</script>